import type { Program, ProgramPostContentObjectList } from 'models';
import { Modal, message } from 'ui';
import { useUpdatePostMutation } from '../queries/mutations';
import { PostForm, type PostFormValues } from './post-form';

type P = {
  isOpened: boolean;
  objectData: ProgramPostContentObjectList;
  onCancel: () => void;
  onSuccess: () => void;
  program: Program;
};

const EditPost = ({ isOpened, objectData, onCancel, onSuccess, program }: P) => {
  const { isPending, mutate } = useUpdatePostMutation();

  const onSubmit = (formData: PostFormValues) => {
    mutate(
      { post: formData, postId: objectData.post.id },
      {
        onError() {
          message.error('Failed to edit post.');
        },
        onSuccess() {
          onSuccess();
          message.success('Post was updated.');
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Edit Post" width="medium">
      <Modal.HugContent>
        <PostForm loading={isPending} mode="edit" onSubmit={onSubmit} post={objectData} program={program} />
      </Modal.HugContent>
    </Modal>
  );
};

export default EditPost;
